import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformEntryRestrictions } from './entry-restrictions.transformers';
import type { EntryRestrictionsCollection } from './entry-restrictions.types';

export function entryRestrictionsReducer(
  state: CollectionStateSlice<EntryRestrictionsCollection> = {},
  action: CollectionActions<EntryRestrictionsCollection>,
): CollectionStateSlice<EntryRestrictionsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'entryRestrictions') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<EntryRestrictionsCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformEntryRestrictions,
            ref.path.authUid,
          ),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
